var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.$style.button,attrs:{"href":_vm.href}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }